(ns frontend.view.dashboard.passed.view
  (:require
   [common.localization :as loc]
   [frontend.bootstrap.components :as rbs]
   [frontend.view.components.oppos-per-users-chart :as users-chart]
   [frontend.view.components.pie-semi-circle-chart :as pie-semi-circle]
   [frontend.view.components.top-performer-chart :as top-performer-chart]
   [ui.components.chart.view :as chart]
   [ui.components.card.view :as card]))

(defn component
  [data]
  (let [no-pass-data? (and (not (:pass-reasons data))
                           (not (get-in data [:passed :per-user]))
                           (not (get-in data [:passed :top-performer])))]
    [:div
     [card/card
      [card/header (loc/tr :home-passed)]
      [card/body
       (if no-pass-data?
         [:div
          {:style {:height          "100%"
                   :display         "flex"
                   :flex-direction  "column"
                   :justify-content "center"
                   :text-align      "center"}}
          (loc/tr :no-passed-deals-l30d)]
         [:div.grid.grid-cols-10.gap-4
          [:div
           {:class "col-span-5"}
           [chart/view
            (users-chart/options
             {:largest-bar-color "#FA6938"
              :height 200}
             (get-in data [:passed :per-user]))]]
          [:div
           {:class "col-span-5"}
           [top-performer-chart/component
            {:color "#FA6938"}
            (get-in data [:passed :top-performer])]]
          [:div
           {:class "col-span-10"}
           [chart/view
            (pie-semi-circle/options
             {:size   370
              :height 200}
             (get-in data [:pass-reasons]))]]])]]]))
